import { useAuth } from "../../hooks/GlobalProvider";
import NavbarAuth from "../../components/Navbar/Navbar_Auth";
import { Link } from "react-router-dom";
import {
  FaShoppingCart,
  FaCut,
  FaBalanceScale,
  FaHeartbeat,
  FaLaptopCode,
  FaUserTie,
  FaSchool,
  FaUtensils,
  FaEnvelope,
  FaPhoneAlt,
  FaRedo,
} from "react-icons/fa";
import { RiSecurePaymentFill } from "react-icons/ri";

function Dashboard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-lg text-gray-600">
        Loading your dashboard...
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen text-lg text-red-600">
        Please log in to view your dashboard.
      </div>
    );
  }

  return (
    <div>
      <NavbarAuth />

      <div className="p-6 min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto bg-white shadow-2xl rounded-2xl p-6 sm:p-8 space-y-8">
          {/* Header */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <h1 className="text-3xl font-bold text-yellow-800">
              Welcome, {user.name}!
            </h1>
          </div>

          {/* User Info */}
          <div className="bg-gray-50 border rounded-xl p-6 space-y-3 shadow-inner">
            <div className="flex items-center gap-3 text-gray-800">
              <FaEnvelope className="text-yellow-600" />
              <span className="text-md font-medium break-all">
                Email: {user.emailaddress}
              </span>
            </div>
            <div className="flex items-center gap-3 text-gray-800">
              <FaPhoneAlt className="text-yellow-600" />
              <span className="text-md font-medium">
                Phone: {user.phonenumber}
              </span>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-wrap gap-4">
            <Link
              to="/dashboard/renewal"
              className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-full text-sm font-semibold shadow-md transition"
            >
              <FaRedo />
              Renewal Page
            </Link>

            <Link
              to="/dashboard/paymenthistory"
              className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-full text-sm font-semibold shadow-md transition"
            >
              <RiSecurePaymentFill />
              Payment History
            </Link>
          </div>
        </div>

        {/* Section - Industries We Serve */}
        <section className="text-center mx-auto mt-16 mb-10 px-4 lg:px-20">
          <h2 className="font-extrabold text-transparent text-2xl md:text-5xl lg:text-6xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-600 mb-3">
            Industries We Serve, Globally
          </h2>
          <p className="text-sm font-medium text-black max-w-2xl mx-auto">
            We build efficient, scalable software tailored to each sector.
            Here's a look at the industries we work with:
          </p>
        </section>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 px-4 lg:px-20 mb-16">
          {[
            { icon: FaShoppingCart, label: "Retail" },
            { icon: FaCut, label: "Salons" },
            { icon: FaBalanceScale, label: "Legal & Finance" },
            { icon: FaHeartbeat, label: "Healthcare" },
            { icon: FaLaptopCode, label: "IT Companies" },
            { icon: FaUserTie, label: "Freelancers" },
            { icon: FaSchool, label: "Education" },
            { icon: FaUtensils, label: "Restaurants" },
          ].map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center p-5 border rounded-2xl bg-white hover:bg-gray-50 transition shadow-sm"
            >
              <Icon className="text-4xl text-orange-500 mb-3" />
              <p className="font-medium text-sm">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
